import { Grid } from '@mui/material';
import { validateNotNullOrUndefined } from '@weft/utils';
import { Helmet } from 'react-helmet';
import { useSearchParams } from 'react-router-dom';
import { RegisterConfirmationPageForm } from './register-confirmation-page-components/RegisterConfirmationPageForm';

export const RegisterConfirmationPage: React.FC = () => {
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token');

  validateNotNullOrUndefined(token, 'token');

  return (
    <>
      <Helmet>
        <title>Confirm User</title>
      </Helmet>
      <Grid
        container
        style={{ height: '100vh', overflow: 'hidden' }}
      >
        <Grid
          item
          lg={5}
          width="100%"
          display="flex"
          justifyContent="center"
          alignItems="center"
        >
          <RegisterConfirmationPageForm token={token}/>
        </Grid>
        <Grid
          item
          display={{ xs: 'none', lg: 'flex' }}
          lg={7}
          sx={{
            background: 'linear-gradient(to bottom, #492f84, #36336a, #111d2d)',
            justifyContent: 'flex-end',
            overflow: 'hidden',
          }}
        >
          <img
            src="/assets/images/login-background.webp"
            alt="Vayu login background"
            style={{
              maxWidth: '100vw',
              maxHeight: '100vh',
              userSelect: 'none',
              pointerEvents: 'none',
            }}
          />
        </Grid>
      </Grid>
    </>
  );
};
